import {
    VERIFIED_USER_LISTING_REQUEST,
    VERIFIED_USER_LISTING_FAIL,
    VERIFIED_USER_LISTING_SUCCESS,
    VERIFIED_USER_LISTING_UPDATE_USER_STATUS,
} from "../../constants/actions.js";
import { ApiURLs } from "../../../constant/ApiUrls.jsx";
import {  fetchData, } from "../../../services/api.js";


export const verifiedUserLisitingRequest = (sortField,sortOrder,page=1,pageSize=10 ) => {
  console.log('000000000000000000',sortField,sortOrder);
  return async (dispatch) => {
    // const url = ApiURLs.GET_USERS;
    const url = `${ApiURLs.GET_USERS}?sortField=${sortField}&sortOrder=${sortOrder}&page=${page}&limit=${pageSize}`;

    // wait untill the data not received so getData function take data and url part
    dispatch(verifiedUserLisitingReq());
    try {
      var userResData = await fetchData(url);
      console.log(`response when we try to login ${JSON.stringify(userResData)}`)
      if (userResData.status === 1) {
        dispatch(verifiedUserLisitingSuccess(userResData.data));
      
      } else {
        dispatch(verifiedUserLisitingFailure());
      }
    } catch (error) {
      dispatch(verifiedUserLisitingFailure());
      console.log(`error while try to login ${error}`)
    }
  }
};


export const verifiedUserLisitingReq = () => {
  return {
    type: VERIFIED_USER_LISTING_REQUEST,
  };
};

export const verifiedUserLisitingSuccess = (users) => {
  return {
    type: VERIFIED_USER_LISTING_SUCCESS,
    payload: users,
  };
};

// actions/userActions.js
export const verifiedUserLisitingUpdateUserStatus = (dataToBeUpdate) => ({
  type: VERIFIED_USER_LISTING_UPDATE_USER_STATUS,
  payload: dataToBeUpdate,
});


export const verifiedUserLisitingFailure = () => {
  return {
    type: VERIFIED_USER_LISTING_FAIL,
  };
};


